import { Component, inject } from '@angular/core';
import { WebAppConfigService } from '../../core/services/webapp-config.service';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-footer',
  imports: [CommonModule],
  templateUrl: './footer.html',
  styleUrl: './footer.css',
})
export class Footer {
  webAppConfig = inject(WebAppConfigService);
}
